import { baseApi } from "../redux/baseAPI";
import { parseResponse } from "../utils/common_lib";

export const aclApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserPermissions: builder.query({
      query: () => ({
        url: `/acl/get_user_permissions.json`,
        method: "GET",
      }),
      transformResponse: (response) => parseResponse({ data: response }),
    }),
  }),
});

export const { useGetUserPermissionsQuery, useLazyGetUserPermissionsQuery } = aclApi;
